import { Grid } from "@material-ui/core";
import React from "react";

import { CmsRenderContentMapper } from "../content/CmsRenderContentMapper";
import { CmsRenderLayoutProps } from "./CmsRenderLayoutProps";

export function CmsRenderLayoutOneTwoOne({ section }: CmsRenderLayoutProps) {
    return (
        <>
            <Grid item xs={3}>
                <CmsRenderContentMapper content={section.content[0]} />
            </Grid>
            <Grid item xs={6}>
                <CmsRenderContentMapper content={section.content[1]} />
            </Grid>
            <Grid item xs={3}>
                <CmsRenderContentMapper content={section.content[2]} />
            </Grid>
        </>
    );
}
